//small check 
export const environment = {
    production: true,
    apiBaseUrl: 'https://uat.mydreamuniversity.in/api',
    registerBaseUrl: 'https://app-backend.foreignadmits.com/api'
};
